// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"7a5e28b6fc43237cc0bb","293":"5d0007e5e6a11d73f6fe","518":"9ad361be5e5b37d9f3ac","779":"deb9ce857aa3c4fc4f22"}[chunkId] + ".js";
};